// shared storage models, base model
export interface IStorageBaseModel {
  readonly Name: string;
}

export enum ToastMessageType {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
  DEFAULT = 'default'
}

export class ToastMessage {
  messages: string[] = [];
  type: ToastMessageType = ToastMessageType.DEFAULT;
}

export interface ConfirmationModal {
  messages: string[];
  okText: string;
  cancelText: string;
}
export function createConfirmationModal(): ConfirmationModal {
  return {
    messages: [],
    okText: 'OK',
    cancelText: 'Cancel'
  };
}

export interface ConfirmationModal {
  messages: string[];
  okText: string;
  cancelText: string;
}

export enum Role {
  ApAs = 'ApAs',	                // Approve assessment for other Experts
  AsUs = 'AsUs',	                // Assign User
  ClCa = 'ClCa',	                // Archive case
  ClDe = 'ClDe',	                // Claims department
  CrInIn = 'CrInIn',	            // Create invoice / Honorary note
  AtApNe = 'AtApNe',	            // Approval needed for attachments
  HoApNe = 'HoApNe',	            // Approval needed for honaray note
  DiHoNoNoApNe = 'DiHoNoNoApNe',	// No approval needed for honorary notes
  ReApNe = 'ReApNe',	            // Approval needed for reports
  RiApNe = 'RiApNe',	            // Approval needed for RIM
  SvApNe = 'SvApNe',	            // Approval needed for SVS
  TeMeApNe = 'TeMeApNe',	        // Approval needed for txt messages
  ExFiLoAd = 'ExFiLoAd',	        // Create RIM / SVS / Reports
  InFiLoAd = 'InFiLoAd',	        // Inspector
  ReViDi = 'ReViDi',	            // Reports for DIB
  SuVi = 'SuVi',	                // Supervisor
  CoCaIn = 'CoCaIn',              // Consult Cases abriviation Inspectors
  CoCaEx = 'CoCaEx',              // Consult Cases abriviation External agencies
}

export enum Company {
  Belfius = 'DIB'
}
